import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class NameApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { groupsActors, id, responseActor } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;
        return {
            question: id,
            data: groupsActors.flatMap((groupActor) => {
                const { id: groupId, responses } = groupActor.getSnapshot().context;
                return Object.keys(responses).map((key) => ({
                    group: groupId,
                    answer: parseInt(key),
                    bool: true,
                    text: String(responses[key]?.getSnapshot().context?.value),
                }));
            }),
            comment,
        };
    }

    public validate({ answersActors, groupsActors, params: { required } }: QuestionContext): boolean {
        if (required) {
            const rowCount = answersActors.filter(
                (a) => a.getSnapshot().context.hidden !== true && a.getSnapshot().context.hiddenByAnswersHide !== true,
            ).length; // TODO check this actually works

            return groupsActors.every((groupActor) => {
                const group = groupActor.getSnapshot().context;
                const responseIds = [...Object.keys(group.responses)].filter((id) => {
                    const answer = answersActors.find((a) => a.getSnapshot().context.id.toString() === id.toString());
                    return (
                        answer?.getSnapshot().context.hidden !== true &&
                        answer?.getSnapshot().context.hiddenByAnswersHide !== true
                    );
                });
                if (responseIds.length < rowCount) return false;

                return (
                    responseIds.length > 0 &&
                    responseIds.every((key) => !!group.responses[key].getSnapshot().context.value)
                );
            });
        }

        return true;
    }
}
